import { DeepPartial } from "@services/type-utils";
import { defaultsDeep } from "lodash";

export const generateMockData =
  <T>(defaultData: T) =>
  (override: DeepPartial<T> = {}): T => {
    return defaultsDeep(override, defaultData);
  };
